import { render, staticRenderFns } from "./custom-native-smart-banner.vue?vue&type=template&id=afae3506&"
import script from "./custom-native-smart-banner.vue?vue&type=script&lang=js&"
export * from "./custom-native-smart-banner.vue?vue&type=script&lang=js&"
import style0 from "./custom-native-smart-banner.vue?vue&type=style&index=0&id=afae3506&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports